module.exports = __webpack_public_path__ + "static/this-is-april-8c0e844d91724fe4c56622ef07ea6f46.png";